import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { Avatar } from "../components/Posts";
import { api, getUser, canClinical } from "../api";
import { formatProName } from "../lib/proName";

// Pro/struttura: elenco follower (privacy-safe, con link alla Bio consentita).
// Paziente: elenco dei seguiti ordinati per data di follow (piu' recenti prima).
export default function Followers() {
  const { t, i18n } = useTranslation();
  const u = getUser();
  const isProOrg = u?.role === "professional" || u?.role === "organization";
  const bioBase = u?.role === "organization" ? "/org-bio" : "/bio";
  const clinical = canClinical(u);  // etichetta Bio coerente con l'attività clinica
  const [list, setList] = useState(null);
  useEffect(() => {
    if (isProOrg) api.get("/me/followers").then(({ data }) => setList(data.followers)).catch(() => setList([]));
    else api.get("/me/follows").then(({ data }) => setList(data)).catch(() => setList([]));
  }, []);
  return (<Layout><div className="yp-container py-8 max-w-2xl">
    <h1 className="text-3xl font-bold mb-6">{isProOrg ? t("followx.followers") : t("followx.following_title")}</h1>
    <div className="space-y-2">
      {list !== null && list.length === 0 && (
        <div className="text-slate-400" data-testid="followers-empty">{isProOrg ? t("followx.empty") : t("followx.following_empty")}</div>)}

      {isProOrg && (list || []).map((x) => (
        <Link key={x.id} to={`${bioBase}/${x.id}`} className="yp-card p-3 flex items-center justify-between gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="follower-row">
          <span className="flex items-center gap-2 min-w-0">
            <Avatar url={x.avatar_url} label={x.nickname} cls="w-9 h-9 text-sm" />
            <span className="truncate">{x.nickname}</span>
          </span>
          <span className="text-sm text-blue-600 shrink-0">{clinical ? t("followx.health_bio") : t("followx.bio")}</span>
        </Link>))}

      {!isProOrg && (list || []).map((x) => (
        <Link key={x.id} to={x.role === "organization" ? `/organizations/${x.id}` : `/professionals/${x.id}`}
          className="yp-card p-3 flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="following-row">
          <Avatar url={x.avatar_url} label={x.org_name || x.first_name} org={x.role === "organization"} cls="w-9 h-9 text-sm" />
          <div className="min-w-0">
            <div className="font-medium truncate">{x.role === "organization" ? x.org_name : formatProName({ title: x.professional_title, first_name: x.first_name, last_name: x.last_name }, i18n.language)}</div>
            <div className="text-xs text-slate-500">{x.role === "organization" ? t("searchx.orgs") : t("searchx.pros")}</div>
          </div>
        </Link>))}
    </div>
  </div></Layout>);
}
